import { api_request } from '../axios_client';
import { handleError } from '../common';
import * as Constants from '../constants';

const isSI = true;
const v1SiPoDownloadSampleGet = async (flag, options) => {
  const resourcePath = `${Constants.PATH.SALES.CUSTOMER_PO.downloadSample}`;
  try {
    const res = await api_request({
      methodType: 'get',
      resourcePath,
      params: { flag },
      options,
      isSI
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const v1SiPoListGet = async (params, signal, options) => {
  const resourcePath = `${Constants.PATH.SALES.CUSTOMER_PO.list}`;
  try {
    const res = await api_request({
      methodType: 'post',
      resourcePath,
      params,
      data: options,
      signal,
      options,
      isSI
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const v1SiPoSummaryGet = async (params, signal, options) => {
  const resourcePath = `${Constants.PATH.SALES.CUSTOMER_PO.summary}`;
  try {
    const res = await api_request({
      methodType: 'post',
      resourcePath,
      params,
      data: options,
      signal,
      options,
      isSI
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const v1SiPoFiltersGet = async (signal, options) => {
  const resourcePath = `${Constants.PATH.SALES.CUSTOMER_PO.filters}`;
  try {
    const res = await api_request({
      methodType: 'get',
      resourcePath,
      signal,
      options,
      isSI
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const v1SiPoIdDeleteSkuPut = async (id, file_id, options) => {
  const resourcePath = `${Constants.PATH.SALES.CUSTOMER_PO.si_po}/${id}${Constants.PATH.SALES.CUSTOMER_PO.deleteSKU}`;
  try {
    const res = await api_request({
      methodType: 'put',
      resourcePath,
      params: { file_id },
      options,
      isSI
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const v1SiPoIdSendForAllocationPut = async (id, options) => {
  const resourcePath = `${Constants.PATH.SALES.CUSTOMER_PO.si_po}/${id}${Constants.PATH.SALES.CUSTOMER_PO.sendForAllocation}`;
  try {
    const res = await api_request({
      methodType: 'put',
      resourcePath,
      options,
      isSI
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const v1SiPoIdEditPoPut = async (data, id, options) => {
  const resourcePath = `${Constants.PATH.SALES.CUSTOMER_PO.si_po}/${id}${Constants.PATH.SALES.CUSTOMER_PO.editPO}`;
  try {
    const res = await api_request({
      methodType: 'put',
      resourcePath,
      data,
      options,
      isSI
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const v1SiPoIdSkuValidatePost = async (id, file, options) => {
  const resourcePath = `${Constants.PATH.SALES.CUSTOMER_PO.si_po}/${id}${Constants.PATH.SALES.CUSTOMER_PO.validateSKU}`;
  try {
    const res = await api_request({
      methodType: 'post',
      resourcePath,
      data: { file },
      options,
      isSI
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const v1SiPoIdSkuSubmitPost = async (buyerPoFile, skuFileId, id, options) => {
  const resourcePath = `${Constants.PATH.SALES.CUSTOMER_PO.si_po}/${id}${Constants.PATH.SALES.CUSTOMER_PO.submitSKU}`;
  try {
    const res = await api_request({
      methodType: 'post',
      resourcePath,
      data: { buyerPoFile, fileId: skuFileId },
      options,
      isSI
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const v1SiPoCreatePoPost = async (data, options) => {
  const resourcePath = `${Constants.PATH.SALES.CUSTOMER_PO.createPO}`;
  try {
    const res = await api_request({
      methodType: 'post',
      resourcePath,
      data,
      options,
      isSI
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const v1SiPoIdSyncPut = async (id, options) => {
  const resourcePath = `${Constants.PATH.SALES.CUSTOMER_PO.si_po}/${id}${Constants.PATH.SALES.CUSTOMER_PO.sync}`;
  try {
    const res = await api_request({
      methodType: 'put',
      resourcePath,
      options,
      isSI
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const v1SiPoIdUploadPoPut = async (id, file, options) => {
  const resourcePath = `${Constants.PATH.SALES.CUSTOMER_PO.si_po}/${id}${Constants.PATH.SALES.CUSTOMER_PO.uploadPO}`;
  try {
    const res = await api_request({
      methodType: 'put',
      resourcePath,
      data: { file },
      options,
      isSI
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const v1SiPoAllocateIdPut = async (id, file, options) => {
  const resourcePath = `${Constants.PATH.SALES.CUSTOMER_PO.allocatePO}/${id}`;
  try {
    const res = await api_request({
      methodType: 'put',
      resourcePath,
      data: { file },
      options,
      isSI
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const v1SiPoOptionsGet = async (po_type, options) => {
  const resourcePath = `${Constants.PATH.SALES.CUSTOMER_PO.options}`;
  try {
    const res = await api_request({
      methodType: 'get',
      resourcePath,
      params: { po_type },
      options,
      isSI
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const v1SiPoDetailsIdGet = async (id, options) => {
  const resourcePath = `${Constants.PATH.SALES.CUSTOMER_PO.details}/${id}`;
  try {
    const res = await api_request({
      methodType: 'get',
      resourcePath,
      options,
      isSI
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const v1SiPoCloseIdPut = async (id, remark, options) => {
  const resourcePath = `${Constants.PATH.SALES.CUSTOMER_PO.closePO}/${id}`;
  try {
    const res = await api_request({
      methodType: 'put',
      resourcePath,
      params: { remark },
      options,
      isSI
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const v1SiPoCancelIdPut = async (id, reason, options) => {
  const resourcePath = `${Constants.PATH.SALES.CUSTOMER_PO.cancelPO}/${id}`;
  try {
    const res = await api_request({
      methodType: 'put',
      resourcePath,
      params: { reason },
      options,
      isSI
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const v1SiPoDownloadSkuListGet = async (id, reason, options) => {
  const resourcePath = `${Constants.PATH.SALES.CUSTOMER_PO.si_po}/${id}${Constants.PATH.SALES.CUSTOMER_PO.downloadSKUList}`;
  try {
    const res = await api_request({
      methodType: 'get',
      resourcePath,
      options
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

export {
  v1SiPoDownloadSampleGet,
  v1SiPoIdDeleteSkuPut,
  v1SiPoIdSkuValidatePost,
  v1SiPoIdSyncPut,
  v1SiPoOptionsGet,
  v1SiPoDetailsIdGet,
  v1SiPoCloseIdPut,
  v1SiPoCancelIdPut,
  v1SiPoListGet,
  v1SiPoSummaryGet,
  v1SiPoFiltersGet,
  v1SiPoIdSkuSubmitPost,
  v1SiPoIdUploadPoPut,
  v1SiPoIdEditPoPut,
  v1SiPoCreatePoPost,
  v1SiPoIdSendForAllocationPut,
  v1SiPoAllocateIdPut,
  v1SiPoDownloadSkuListGet
};
